// resolveLinkTarget maps a sanitized absolute URL to the value handed to Link's
// `to`. Same-origin URLs (e.g. workspace/panel deep links) are returned as a
// relative path so Link routes them through react-router and navigates in the
// current window; cross-origin URLs are returned unchanged so Link opens them
// in a new tab.
export function resolveLinkTarget(sanitizedHref: string): string {
  const url = new URL(sanitizedHref);
  return url.origin === window.location.origin
    ? url.pathname + url.search + url.hash
    : sanitizedHref;
}
